import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetWhatsappLink } from "./service";

export const useGetWhatsappLink = ({ options }) => {
  return useQuery(
    [queryKey.WHATSAPP_LINK],
    () =>
      apiGetWhatsappLink({}).then((res) => {
        return res.data;
      }),
    {
      staleTime: 10 * (60 * 1000), //10mins
      cacheTime: 10 * (60 * 1000), //10mins
      ...options,
    },
  );
};
